module.exports = __webpack_public_path__ + "static/media/lastWeeklyUpdate.71e7dda6.png";